import * as $http from 'axios';

const vital = {};

const models = ['operations', 'cares'];

models.forEach((modelName) => {
  vital[modelName] = {
    all: (params) => $http.get(`nurse/${modelName}/vitalitems`, { params }),
    delete: (model) => $http.delete(`nurse/${modelName}/vitalitems/${model}`),
    update: (model) => $http.put(`nurse/${modelName}/vitalitems/multi`, model),
    visible: (model) =>
      $http.put(`nurse/${modelName}/vitalitems/${model.id}`, model),
    all_v2: (params) =>
      $http.get(`nurse/v2/${modelName}/vitalitems`, { params }),
    delete_v2: (model) =>
      $http.delete(`nurse/v2/${modelName}/vitalitems/${model}`),
    update_v2: (model) =>
      $http.put(`nurse/v2/${modelName}/vitalitems/multi`, model),
    visible_v2: (model) =>
      $http.put(`nurse/v2/${modelName}/vitalitems/${model.id}`, model),
  };
});

export default vital;
